import React from 'react';
import { AppButton, Box, Inscription, LinkButton, WarningCard } from '@common-fe/common-fe';

export enum ActionButtonType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LINK = 'link',
}

interface Action {
  label?: string;
  icon?: React.ReactNode;
  testId: string;
  onClick?: () => void;
  buttonType?: ActionButtonType;
  isFlexible?: boolean;
  height?: string;
}

interface Props {
  testId: string;
  title: string;
  description: string | React.ReactNode;
  actions?: Action[];
  actionsGap?: string;
}

const ClaimWarningCard: React.FC<Props> = ({ testId, title, description, actions, actionsGap }) => (
  <WarningCard
    testId={testId}
    backgroundColor="missingContainer"
    borderColor="missingBorder"
    topBorderColor="missingContainer"
    containerProps={{ pad: 'spacing16', gap: 'spacing12' }}
    title={
      <Box gap="spacing4">
        <Inscription data-testid={`${testId}_title`} weight="bold" color="textBody" lineHeight="20px">
          {title}
        </Inscription>

        {typeof description === 'string' ? (
          <Inscription data-testid={`${testId}_description`} color="textBody" lineHeight="20px">
            {description}
          </Inscription>
        ) : (
          description
        )}
      </Box>
    }
  >
    {actions?.length ? (
      <Box direction="row" align="center" gap={actionsGap ?? 'spacing12'} width="100%">
        {actions.map((action) => {
          if (action.buttonType === ActionButtonType.LINK) {
            return (
              <Box key={action.testId}>
                <LinkButton testId={action.testId} onClick={action.onClick} linkInlineMode>
                  {action.icon || action.label}
                </LinkButton>
              </Box>
            );
          }

          return (
            <Box
              key={action.testId}
              style={action.isFlexible ? { flex: '1 0 0', minWidth: 0 } : undefined}
              {...(action.isFlexible ? { direction: 'column', align: 'stretch' } : {})}
            >
              <AppButton
                testId={action.testId}
                buttonType={(action.buttonType as 'primary' | 'secondary') ?? 'primary'}
                onClick={action.onClick}
                size="M"
                width={action.isFlexible ? '100%' : undefined}
                style={{
                  ...(action.isFlexible ? { width: '100%' } : {}),
                  ...(action.height ? { height: action.height } : {}),
                }}
              >
                {action.label}
              </AppButton>
            </Box>
          );
        })}
      </Box>
    ) : null}
  </WarningCard>
);

export default ClaimWarningCard;
